import { render } from "./accordion.vue?vue&type=template&id=0ca82524&scoped=true&ts=true"
import script from "./accordion.vue?vue&type=script&lang=ts"
export * from "./accordion.vue?vue&type=script&lang=ts"

import "./accordion.vue?vue&type=style&index=0&id=0ca82524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca82524"]])

export default __exports__